import { useProjectId } from 'store/project';
import { Store, useCreateStore } from 'hooks/createStore';
import { useEffect } from 'react';
import { LocalStorageManager } from 'services/storage/LocalStorageManager';

export function useDocumentationProgressActivityStore(
  issuesVisibleStore: Store<boolean>
): Store<boolean> {
  const projectId = useProjectId();
  const initialActiveState = LocalStorageManager.getDocumentationProgressActive(projectId);
  const activityStore = useCreateStore(initialActiveState);

  useEffect(() => {
    const action = (): void => {
      const active = activityStore.get();
      if (active) issuesVisibleStore.set(active);
    };

    action();
    return activityStore.subscribe(action);
  }, [activityStore, projectId, issuesVisibleStore]);

  useEffect(() => {
    const action = (): void => {
      const issuesVisible = issuesVisibleStore.get();
      if (!issuesVisible) {
        activityStore.set(false);
      }
      if (issuesVisible) {
        const initialActiveState = LocalStorageManager.getDocumentationProgressActive(projectId);
        activityStore.set(initialActiveState);
      }
    };
    action();
    return issuesVisibleStore.subscribe(action);
  }, [activityStore, issuesVisibleStore, projectId]);

  return activityStore;
}
